import styled from 'styled-components';

import { Input } from 'components/Input';

const PurchaseInput = styled(Input)`
  margin-left: 12rem;
  margin-right: 4rem;
`;

export { PurchaseInput };
